var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat; // @TODO: add support for assembly language specifier


var InlineAssemblyStatement = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return concat(['assembly ', path.call(_print, 'body')]);
  }
};
module.exports = InlineAssemblyStatement;